import { Routes } from '@angular/router';
import { DefaultBodyComponent } from './layout/default-body/default-body.component';
import { LoginComponent } from './pages/login/login.component';
import { SalaryConfirmationComponent } from './pages/salary-confirmation/salary-confirmation.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'salary-confirmation',
    component: SalaryConfirmationComponent,
  },
  {
    path: '',
    component: DefaultBodyComponent,
    data: {
      title: 'Dashboard',
    },
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
];
